// import Dispatchers from '@/mixins/dispatchers';

export default {
  name: 'BastanteoItem',

  // mixins: [Dispatchers],

  /**
   * @override
   */
  data() {
    return {
      checked: false,
      opened: false
    };
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number
    },
    type: {
      type: String,
      required: true
    },
    uuid: {
      type: String,
      required: true
    },
    objectData: {
      type: Object,
      required: false
    },
    documentTitleFragment: {
      type: String,
      required: false
    },
    videoSibling: {
      type: Object,
      required: false,
      default: null
    }
  },

  methods: {
    /**
     * Conteo de incidencias pendientes del item
     * @param {Object} item documento
     * @return {Number} numero de incidencias pendients (bloqueantes + no bloqueantes)
     */
    issuesPending(item) {
      const n_blocking_issues = item.blocking_issues ? item.blocking_issues.length : 0;
      const n_no_blocking_issues = item.no_blocking_issues ? item.no_blocking_issues.length : 0;
      return n_blocking_issues + n_no_blocking_issues;
    },

    /**
     * Emite el item a validar al componente de bastanteo
     */
    addItemToValidate() {
      if (this.item && !this.item.is_validated && !this.item.is_rejected) {
        // if (this.item.title && !this.item.is_validated) {
        this.$root.$emit('emit_item_to_validate', this.item, this.type, this.uuid);
      }
    },

    /**
     * Despliega (o no) la información del item con estas opciones
     * - abrir caso: siempre
     * - subir documento: si no tiene uuid (osea, hay categoria pero no documento)
     * - Subir documento: si tiene uuid (osea, hay documento) y es firmable y no está firmado
     * - validar: si tiene uuid (osea, hay documento) y no es OTHERS
     */
    checkOpened() {
      this.opened = !this.opened;
    },

    /**
     * Emite el evento para que se muestre el bloque de subida de documento
     * @param {Object} bankAccout objeto de bank account (si se va a subir un documento de este tipo)
     */
    upload(bankAccout) {
      this.opened = true;
      this.$root.$emit('emit_show_upload', this.item, this.type, this.uuid, true, bankAccout);
    },

    /**
     * Abre la pestaña para crear una incidencia
     * TODO: revisar funcionalidad cuando nos pongamos con cosas de incidencias
     */
    openIssue() {
      const typeObject = this.item.uuid_intervener ? 'intervener' : this.item.uuid_operation ? 'operation' : 'account';
      this.$router.replace({
        name: 'issues_add_view',
        query: {
          id: this.uuid,
          alias: this.objectData ? this.objectData.uuid : '',
          name: this.item.key_subcategory,
          subject: this.$t(`documents.subcategories.${this.item.key_subcategory}`),
          view: 'issue-details',
          type: this.item.key_category,
          category: this.item.key_category,
          document_subcategory: this.item.key_subcategory,
          document: this.item.uuid,
          typeObject
        }
      });
    },

    /**
     * Valida un item
     * @param {Boolean} validate Validar o invalidar un documento
     */
    validateItem(validate) {
      // SI tiene blocking_issues no hacer nada y se intenta validar
      // TODO: revisar... debería mostrarse un error, no?
      if (this.item.blocking_issues > 0 && validate) {
        return;
      }

      const payload = {
        uuid: this.uuid,
        uuidDocument: this.item.uuid,
        data: { validated: validate }
      };
      this.$documentsService.update(this.type, payload).then(() => {
        if (validate) {
          this.$toast.success(`Documento validado`, `Se ha validado el documento.`);
        } else {
          this.$toast.success(`Documento invalidado`, `Se ha invalidado el documento.`);
        }

        switch (this.type) {
          case 'intervener':
          case 'interveners':
            this.$root.$emit('refresh_intervener');
            this.$root.$emit('refresh_account');
            this.$root.$emit('refresh_operation');
            break;
          case 'account':
            this.$root.$emit('refresh_account');
            this.$root.$emit('refresh_operation');
            break;
          case 'operation':
            this.$root.$emit('refresh_operation');
            break;
          default:
            break;
        }
      });
    },

    /**
     * Este método debería abrir la pestaña de incidencias
     * con el filtro correspondiente para sacar las incidencias del documento
     */
    openIssuesDoc() {
      // TODO: implementar
    },
    canCancelValidation(item) {
      const meetsItemRequirements = item.uuid && item.key_category !== 'OTHERS' && item.is_validated;
      const meetsEntityRequirements =
        this.entityStatus &&
        (this.entityStatus === 'VALIDATED' ||
          this.entityStatus === 'VALIDADO' ||
          this.entityStatus === 'SIGNED' ||
          this.entityStatus.includes('REGISTERED'));
      return meetsItemRequirements && meetsEntityRequirements;
    },

  },
  computed: {
    entityStatus() {
      switch (this.type) {
        case 'intervener':
        case 'interveners':
          return this.objectData ? this.objectData.intervener_status : undefined;
        case 'account':
          return this.objectData ? this.objectData.status : undefined;
        case 'operation':
          return this.objectData ? this.objectData.operation_status : undefined;
        default:
          return undefined;
      }
    },
    nonSignedPendings() {
      if (!this.item || !this.item.non_signed_by || !this.item.non_signed_by.length) {
        return [];
      } else {
        return this.item.non_signed_by.filter(intervener => intervener.signature_status === 'PENDIENTE_DIGITAL');
      }
    }
  }
};
